/**
 * Created by - Sameer on 07-11-2025
 * Reason - To have Produc section
 */

import { useContext, useEffect, useState } from "react";
import styles from "./Product.module.css";
import { getProductDetailsApi } from "../../Api/services";
import config from "../../Api/config";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const Product = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [productList, setProductList] = useState([]);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    productDetails();
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Products", path: "/products" },
    ]);
  }, []);

  const productDetails = async () => {
    try {
      const response = await getProductDetailsApi();
      // Try different possible response structures
      const products =
        response?.product_details || response?.products || response?.data || [];

      setProductList(products);
    } catch (error) {
      console.error("Error fetching product details:", error);
    } finally {
      setShowContent(true);
    }
  };

  const getTextPreview = (htmlContent, wordLimit = 20) => {
    if (!htmlContent) return "";
    const text = htmlContent.replace(/<[^>]*>/g, "");
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <>
      {showContent ? (
        <div>
          {/* Main container should only show when there's data */}
          {productList?.length > 0 ? (
            <div className={`${styles.mainContainer}`}>
              <NavigationPath navigationPathArray={navigationPath} />

              {/* Page Title - same structure as News */}
              <div className={styles.pageTitle}>
                <div className={styles.title}>
                  <span className={styles.firstThree}>Pro</span>
                  <span className={styles.gradientText}>ducts</span>
                </div>
              </div>

              {/* Products Container */}
              <div className={`${styles.productsContainer}`}>
                {productList?.map((product, index) => {
                  return (
                    <div
                      className={`${styles.productCard}`}
                      key={product.id || index}
                    >
                      <div className={`${styles.productImageContainer}`}>
                        <img
                          src={
                            product.image
                              ? config.baseURL + product.image
                              : "/default-product.png"
                          }
                          alt={product.title || "Product Image"}
                          className={`${styles.productImage}`}
                          onError={(e) => {
                            e.target.src = "/default-product.png";
                          }}
                        />
                      </div>
                      <div className={`${styles.productContent}`}>
                        <div className={`${styles.productTitle}`}>
                          {product.title}
                        </div>
                        <div className={`${styles.productoverview}`}>
                          {getTextPreview(product.overview, 10)}
                        </div>
                        <div>

                        <div className={`${styles.readMore}`}>
                          <Link
                            to={"/product_detail"}
                            state={product?.id}
                            className={`${styles.navigationLink}`}
                            >
                            Read more
                          </Link>
                        </div>
                            </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            // Show "No products available" when there's no data
            <div className={`${styles.mainContainer}`}>
              <NavigationPath navigationPathArray={navigationPath} />
              <p className={styles.noDetailsAvailableText}>
                No products available
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.loaderContent}>
          <img
            style={{ height: "30vh" }}
            src="adyant_loader.gif"
            alt="Loading..."
          />
        </div>
      )}
    </>
  );
};

export default Product;

/**
 * End of code - Sameer on 07-11-2025
 * Reason - To have Produc section
 */